<div class="mb-3" [class.invalid-feedback]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id" class="label">
      {{ props.label }}
      @if (props.required && props.hideRequiredMarker !== true) {
        <span>*</span>
      }
      @if (key == 'classId') {
        <span style="position:absolute; margin-top: -2px;  margin-left: 8px;" class="filter-select-custom-description">
          <tui-icon i18n-nbTooltip="@@SelectTypeToViewRestFiltersDesc" nbTooltip="Для получения дополнительных фильтров необходимо выбрать тип изделия" style="vertical-align: middle;" icon="info"/>
        </span>
      }
    </label>
  }

  @if (!props.simple) {
    <div>
      <ng-select
        size="small"
        i18n-placeholder="@@Select"
        [id]="id"
        appendTo="body"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [items]="selectOptions"
        [multiple]="isMultiple"
        placeholder="Выберите значение"/>
    </div>
  } @else {
    <div style="display: flex">
      <nb-select
        [id]="id"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [multiple]="isMultiple"
        i18n-placeholder="@@VyberiteZnachenie" placeholder="Выберите значение"
        fullWidth
        size="tiny"
        >
        @for (item of selectOptions; track item) {
          <nb-option [value]="item.value" [disabled]="item.disabled">{{item.label}}</nb-option>
        }
      </nb-select>

      @if (hasValue) {
        <button nbButton size="small" status="control" (click)="clear()" type="button">
          <tui-icon icon="x"/>
        </button>
      }
    </div>
  }

  @if (showError) {
    <div class="invalid-feedback">
      <formly-validation-message [field]="field"/>
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
